import { createContext } from "react";

export const Context = createContext({
  domainName: null as string | null | undefined,
  collectorSubdomain: null as string | null | undefined,
  tableOfContents: {} as Record<string, string>,
  addItemToTOC: null as null | ((key: string, value: string) => void),
});
